import { useCallback } from 'react';

import {
  type CompanyMembersPage,
  useCompanyMembersParams,
} from '@/features/companyDashboard/common/members/useCompanyMembersParams';
import { useDownloadUsersCSVMutation } from '@/store/api/userApi';

const saveBlob = (blob: Blob, filename: string) => {
  const downloadUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = downloadUrl;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(downloadUrl);
};

// Downloads the members the page's table currently filters to, with the table's own params.
export const useDownloadUsersCsv = (
  page: CompanyMembersPage,
  companyName?: string,
) => {
  const params = useCompanyMembersParams(page);
  const [downloadUsersCsv, { isLoading }] = useDownloadUsersCSVMutation();

  const download = useCallback(async () => {
    const blob = await downloadUsersCsv(params).unwrap();
    const memberType =
      params.companyMemberStatus === 'past' ? 'past' : 'current';
    const today = new Date().toISOString().split('T')[0];
    saveBlob(
      blob,
      `${companyName || 'company'}_${memberType}_users_${today}.csv`,
    );
  }, [companyName, downloadUsersCsv, params]);

  return { download, isDownloading: isLoading };
};
